import { inject, Injectable } from '@angular/core';
import { exhaustMap, map, Subject, take } from 'rxjs';
import { CanViewPlatformNamespaceRequest, ViewAccessApiService } from '@vendasta/platform-users';
import { debounceTime, tap } from 'rxjs/operators';
import { AtlasConfigService } from './config.service';
import { PamDialogService } from '../../src/lib/pam-dialog/pam-dialog.service';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class PlatformAccessService {
  private readonly configService = inject(AtlasConfigService);
  private readonly viewAccessService = inject(ViewAccessApiService);
  private readonly pamDialogService = inject(PamDialogService);
  private readonly router = inject(Router);

  private readonly checkAccess$$ = new Subject<void>();

  constructor() {
    this.checkAccess$$.pipe(
      debounceTime(200),
      exhaustMap(() =>
        this.configService.config$.pipe(
          take(1),
          exhaustMap((cfg) =>
            this.viewAccessService
              .canViewPlatformNamespace(
                new CanViewPlatformNamespaceRequest({
                  partnerId: cfg.partnerId,
                  accountGroupId: cfg.accountId,
                  groupId: cfg.groupPath,
                  entitlementId: cfg.entitlementId,
                }),
              )
              .pipe(map((resp) => ({ ...resp, ...cfg }))),
          ),
        ),
      ),
      tap((cfgAndResp) => {
        if (cfgAndResp.canViewPlatformNamespace) {
          return;
        } else if (cfgAndResp.canRequestEntitlement) {
          this.pamDialogService.openDialog(cfgAndResp.partnerId, cfgAndResp.accountId, cfgAndResp.defaultPamReason);
        } else {
          this.router.navigate([cfgAndResp.accessDeniedPath ?? '/']);
        }
      }),
      takeUntilDestroyed(),
    ).subscribe();
  }

  public checkPlatformAccess() {
    this.checkAccess$$.next();
  }
}
